import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { CreateDirect } from "@/features/FillOutWizard/CreateDirect";
import { DirectFillOutSettingsFormQuery } from "@/features/FillOutWizard/CreateDirect/graphql";
import { zodRespondentTypeEnum } from "@/models/respondent";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct",
)({
  validateSearch: zodValidator(
    z.object({
      respondentType: zodRespondentTypeEnum,
      measuredQuestionnaireIds: z.array(z.string()),
    }),
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, measurementId } = Route.useParams();
  const { respondentType, measuredQuestionnaireIds } = Route.useSearch();
  const { data } = useSuspenseQuery(DirectFillOutSettingsFormQuery, {
    variables: {
      organizationKey: organizationKey,
      measurementId: measurementId,
      measuredQuestionnaireIds: measuredQuestionnaireIds,
    },
  });

  return (
    <CreateDirect
      measurement={data.organization.measurement}
      respondentType={respondentType}
      measuredQuestionnaireIds={measuredQuestionnaireIds}
    />
  );
}
